// extracted by mini-css-extract-plugin
export default {"checkboxContainer":"CheckboxGroup_checkboxContainer__nVO6U","checkbox":"CheckboxGroup_checkbox__AxaNb"};